function PortalIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#0a0a0a"
      strokeWidth="2.5"
    >
      <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M5 17h-2v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6-6h15m-6 0v-5" />
    </svg>
  );
}

export default function AppHeader({ isAdmin, isAuthenticated, user, onAuthClick }) {
  return (
    <header
      style={{
        padding: "20px 40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <div
          style={{
            width: "48px",
            height: "48px",
            background: "linear-gradient(135deg, #00d4aa 0%, #00a8cc 100%)",
            borderRadius: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(0, 212, 170, 0.3)",
          }}
        >
          <PortalIcon />
        </div>
        <div>
          <h1
            style={{
              margin: 0,
              fontSize: "24px",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: "700",
            }}
          >
            Kjøretøyportal
          </h1>
          <p
            style={{
              margin: 0,
              fontSize: "13px",
              color: "rgba(255,255,255,0.5)",
            }}
          >
            Registrering av bilretur og mottak
          </p>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        {isAdmin && <span className="status-ok">● Admin</span>}
        {isAuthenticated && user && (
          <span style={{ color: "rgba(255,255,255,0.75)", fontSize: "13px" }}>
            {user.fullName} · {user.companyName}
          </span>
        )}
        <button onClick={onAuthClick} className="btn-s" style={{ padding: "10px 20px" }}>
          {isAuthenticated ? "Logg ut" : "Logg inn"}
        </button>
      </div>
    </header>
  );
}
